import React, { useCallback, useEffect, useRef, useState } from "react";
import SubNav from "../../../Shared/SubNav";
import { useNavigate } from "react-router-dom";
import socket from "../../../context/socket";
import AddressProofFormModal from "../../Modals/AddressProofFormModal";
import { Card, Form } from "react-bootstrap";
import PanCardForm from "../../Modals/PanCardForm";
import ChequeFormModal from "../../Modals/ChequeFormModal";

import SignatureCropModal from "../../Modals/SignatureCropModal";
import NomineeDetailsModal from "../../Modals/NomineeDetailsModal";
import { debounce } from "lodash";
import { FaCheck, FaCross, FaDeleteLeft } from "react-icons/fa6";
import CaptureVideo from "./CaptureVideo";
import ApplicantForm from "./ApplicantForm";
import ApplicantFormModal from "./ApplicantFormModal";
import ReactDOM from "react-dom";
import html2canvas from "html2canvas";
import ContactDetailsModal from "../../Modals/ContactDetailsModal";
import AddressProofTypeModal from "./modals/AddressProofTypeModal";
import EditAddressProofTypeModal from "./modals/EditAddressProofTypeModal";
import Swal from "sweetalert2";
import { MdCancel } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../../redux/client/clientSlice";
import api from "../../../utils/api";
import KycStatusListener from "../../../utils/KycStatusListener";

export const AddressProof = ({ isConnected }) => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const navigate = useNavigate();
  const [fileUrl, setFileUrl] = useState(null);

  const [modalShowAddressType, setModalShowAddressType] = useState(false);
  const [modalShowEditAddressType, setModalShowEditAddressType] = useState(false);
  const [modalShowAddressForm, setModalShowAddressForm] = useState(false);
  const [canNomineeTrueFromDeclarationFileUrl, setCanNomineeTrueFromDeclarationFileUrl] = useState(false);
  // console.log('canNomineeTrueFromDeclarationFileUrl',canNomineeTrueFromDeclarationFileUrl);


  const [modalShowPanCardForm, setModalShowPanCardForm] = useState(false);
  const [modalShowChequeForm, setModalShowChequeForm] = useState(false);
  const [modalSignatureFile, setModalSignatureFile] = useState(false);
  const [modalNomineeDetails, setModalNomineeDetails] = useState(false);
  const [modalContectDetails, setModalContactDetails] = useState(false);
  const [modalApplicantForml, setModalApplicantForml] = useState(false);
  const [errorStatusMessage, setErrorStatusMessage] = useState(false);
  const [signatureFile, setSignatureFile] = useState();
  const [frontImage, setFrontImage] = useState(null);
  const [isWebCamSec, setIsWebCamSec] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [kycDoc, setkycDoc] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchClientData(roomId));
  }, [dispatch]);

  console.log("kycDoc", kycDoc);
  const [selectedProofType, setSelectedProofType] = useState(null);


  useEffect(() => {
    if (!roomId) return;
    fetchExistingNomineeFile(roomId);
  }, [roomId]);


  const fetchExistingNomineeFile = async (clientId) => {
    try {
      const response = await api.post("advisor/get-nominee-reference", { client_id: clientId });

      const url = response?.data?.data?.file_path || null;
      console.log("Existing Nominee File URL:", response?.data?.data?.file_path);
      setCanNomineeTrueFromDeclarationFileUrl(url)


      if (url) {
        setFileUrl(url);  // <-- set existing file from API
        socket.emit("nominee_declaration", {
          room: roomId,
          data: {
            // fileName: file.name,
            fileUrl: url,
            // client_id: clientId,
            // response: response?.data
          }
        });
      }


    } catch (error) {
      console.error("Error fetching nominee reference:", error);
    }
  };

  useEffect(() => {
    if (!Array.isArray(kycDoc) || kycDoc.length === 0) {
      setErrorStatusMessage("KYC data not available");
      return;
    }

    const findDoc = (type) => kycDoc.find((doc) => doc.doctype === type);
    const getDataLength = (doc) => Array.isArray(doc?.data) ? doc.data.length : 0;

    const passportDoc = findDoc("passport");
    const aadhaarDoc = findDoc("aadhaar");
    const dlDoc = findDoc("dl");

    const voterIdDoc = findDoc("voterid");
    const chequeDoc = findDoc("cheque");
    const pancardDoc = findDoc("pancard");
    const signatureDoc = findDoc("signature");
    const nomineeDetailsDoc = findDoc("nominee_details");

    const hasPassport = getDataLength(passportDoc) > 0;
    const hasVoterId = getDataLength(voterIdDoc) > 0;
    const hasCheque = getDataLength(chequeDoc) > 0;
    const hasPancard = getDataLength(pancardDoc) > 0;
    const hasNominee = (getDataLength(nomineeDetailsDoc) > 0)
    //  || canNomineeTrueFromDeclarationFileUrl;
    console.log('hasNominee', hasNominee);

    const hasSignatureFront = !!signatureDoc?.fin_doc_url_front;



    if (!hasPassport && !hasVoterId && !aadhaarDoc && !dlDoc) {
      setErrorStatusMessage("Address Proof not completed");
      return;
    }

    // if (!hasPancard) {
    //   setErrorStatusMessage("Pancard verification not completed");
    //   return;
    // }

    if (!hasCheque) {
      setErrorStatusMessage("Cheque verification not completed");
      return;
    }

    if (!hasSignatureFront) {
      setErrorStatusMessage("E-Sign not completed");
      return;
    }

    if (clientData?.kyc_info?.identity !== "03" &&!hasNominee) {
      setErrorStatusMessage("Nominee Details not completed");
      return;
    }

    // ✅ All good — clear any previous error
    setErrorStatusMessage("");
  }, [kycDoc, canNomineeTrueFromDeclarationFileUrl]);

  const [alertMessage, setAlertMessage] = useState({ visible: false, message: "", variant: "", });

  // console.log("kahskfjhas",clientData?.kyc_info.identity);

  const clientAddressProofPhoto =
    (kycDoc && kycDoc.filter((item) => item.doctype === "kyc_photo")) || [];
  const clientAddressProofVideo =
    (kycDoc && kycDoc.filter((item) => item.doctype === "kyc_video")) || [];
  console.log(
    clientAddressProofPhoto[0],
    clientAddressProofVideo[0],
    "clientAddressProofPhoto"
  );

  const { clientData, loading: clientLoading, error: clientError, } = useSelector((state) => state.client);

  useEffect(() => {
    if (roomId && clientData?.kyc_doc?.length > 0) {
      // console.log("panData1", clientData);
      setkycDoc(clientData?.kyc_doc);
    }
  }, [clientData, roomId])

  // Debounced function to emit data
  const sendDataToServer = useCallback(
    debounce((data) => {
      socket.emit("message", { room: roomId, data });
      // console.log("emited data", data);
    }, 500),

    [roomId]
  );

  useEffect(() => {
    sendDataToServer({
      isToggled,
      isWebCamSec,
    });
  }, [sendDataToServer, isToggled, isWebCamSec]);


  useEffect(() => {
    if (!roomId) return;
    socket.on("message_to", (msg) => {
      console.log("resived message_to AddressProof :", msg?.data?.type);
      if (msg?.data?.type === "success") {
        dispatch(fetchClientData(roomId));
      }
    })
  }, [roomId, dispatch]);

  // Handle toggle
  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const handleNext = () => {
    const nextUrl = "/my-investment?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: nextUrl });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const prevUrl = "/what-we-will-need-from-you?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };

  const handleAddressType = (data) => {
    console.log("Address Type : ", data);
  };
  const handleAddressForm = (data) => {
    console.log("Address Form : ", data);
  };
  const handlePanCardForm = (data) => {
    console.log("PanCardForm Form : ", data);
  };

  const handleChequeForm = (data) => {
    console.log("ChequeForm Form : ", data);
  };

  // const handlePanImageChange = async (e) => {
  //   Swal.fire({
  //     text: "Please wait...",
  //     imageUrl: "https://www.finedge.in/assets/images/download.gif",
  //     showConfirmButton: false,
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //   });
  //   const file = e.target.files[0];
  //   // console.log("file", file);
  //   setFrontImage(file);
  //   const formData = new FormData();
  //   formData.append("document_type", "pancard");
  //   formData.append("_id", roomId);
  //   formData.append("documentfile", file);
  //   formData.append("label", "front");

  //   try {
  //     // Send POST request
  //     const response = await api.post(
  //       "advisor/cams_upload_kyc_document",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     // Show appropriate SweetAlert based on status
  //     const res = response.data;

  //     if (res?.kycResponse?.status === "error") {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Upload Failedd',
  //         text: res?.kycResponse?.message || 'Something went wrong!',
  //         confirmButtonColor: '#d33',
  //       });
  //       return
  //     }


  //     console.log(res?.kycResponse?.status, "responsessss", res)
  //     if (res.status === 200 || res.status === 201 || res?.kycResponse?.status === 'success') {
  //       Swal.fire({
  //         icon: "success",
  //         text: response?.data?.message || "Client data updated successfully",
  //         title: "Success",
  //         confirmButtonText: "OK",
  //         customClass: { confirmButton: "swal-confirm-btn" },
  //       }).then(() => {

  //         dispatch(fetchClientData(roomId));

  //         socket.emit("join", { room: roomId });
  //         socket.emit("message_to",
  //           {
  //             room: roomId,
  //             data: {
  //               message: response?.data?.message || "Client data updated successfully",
  //               type: "success",
  //             }

  //           })
  //         console.log("emitted data message_to", roomId, "success");
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Upload Failed',
  //         text: response.data?.message || 'Something went wrong!',
  //         confirmButtonColor: '#d33',
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error uploading files:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Upload Failed",
  //       text:
  //         error?.response?.data?.message ||
  //         "Something went wrong while uploading.",
  //       confirmButtonText: "OK",
  //       customClass: {
  //         confirmButton: "swal-confirm-btn",
  //       },
  //       allowOutsideClick: false,
  //       allowEscapeKey: false,
  //     });
  //   }finally {
  //   input.value = "";
  // }
  //   // e.target.value = null;
  // };

  const handlePanImageChange = async (e) => {
  const input = e.target;
  const file = input.files[0];

  if (!file) return;

  Swal.fire({
    text: "Please wait...",
    imageUrl: "https://www.finedge.in/assets/images/download.gif",
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
  });

  setFrontImage(file);

  const formData = new FormData();
  formData.append("document_type", "pancard");
  formData.append("_id", roomId);
  formData.append("documentfile", file);
  formData.append("label", "front");

  try {
    const response = await api.post(
      "advisor/cams_upload_kyc_document",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    const res = response.data;

    if (res?.kycResponse?.status === "error") {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: res?.kycResponse?.message || "Something went wrong!",
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (
      response.status === 200 ||
      response.status === 201 ||
      res?.kycResponse?.status === "success"
    ) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: res?.message || "Client data updated successfully",
        confirmButtonText: "OK",
      }).then(() => {
        dispatch(fetchClientData(roomId));

        socket.emit("join", { room: roomId });
        socket.emit("message_to", {
          room: roomId,
          data: {
            message: res?.message || "Client data updated successfully",
            type: "success",
          },
        });
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: res?.message || "Something went wrong!",
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Upload Failed",
      text:
        error?.response?.data?.message ||
        "Something went wrong while uploading.",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  } finally {
    // ✅ CRITICAL FIX: allows re-selecting the SAME file
    input.value = "";
  }
};


  const handleChequeChange = async (e) => {
    Swal.fire({
      text: "Please wait...",
      imageUrl: "https://www.finedge.in/assets/images/download.gif",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    const file = e.target.files[0];
    console.log("file", file);

    if (!file) return;

    const formData = new FormData();
    formData.append("document_type", "cheque");
    formData.append("_id", roomId);
    formData.append("documentfile", file);
    formData.append("label", "front");

    try {
      const response = await api.post(
        "advisor/cams_upload_kyc_document",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const res = response.data;
      console.log("response uploading files:", res);

      if (res.status === 200 || res.status === 201 || res.status == "success") {
        Swal.fire({
          icon: "success",
          text: response?.data?.message || "Client data updated successfully",
          title: "Success",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        }).then(() => {

          dispatch(fetchClientData(roomId));

          socket.emit("join", { room: roomId });
          socket.emit("message_to",
            {
              room: roomId,
              data: {
                message: response?.data?.message || "Client data updated successfully",
                type: "success",
              }

            })
          console.log("emitted data message_to", roomId, "success");
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: response.data?.message || 'Something went wrong!',
          confirmButtonColor: '#d33',
        });
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while uploading.",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    }

    e.target.value = null;
  };

  const handleSignatureChange = async (e) => {
    const file = e.target.files[0];
    // console.log("file", file);

    if (file) {
      // Your logic here
      setSignatureFile(file);
      setModalSignatureFile(true);
    }

    // ✅ Reset the input so the same file can be selected again
    e.target.value = null;
  };

  const handWebCamClick = () => {
    setIsWebCamSec(!isWebCamSec);
  };
  const nomineeDetailsModalHide = () => {
    setModalNomineeDetails(false);
    setAlertMessage({ visible: false });
  };
  const contactDetailsModalHide = () => {
    setModalContactDetails(false);
  };

  const handleAddressProofTypeModal = () => {
    setModalShowAddressType(false);
    setModalShowEditAddressType(false);
    setSelectedProofType(null);
  };





  const openEsignDocument = async () => {
    try {
      const response = await api.post(
        `advisor/esignDocument`,
        { client_id: roomId }
      );

      console.log("E-sign document response:", response);

      const base64 = response?.data?.base64;

      if (!base64) {
        console.warn("No base64 PDF data received.");
        alert("No PDF data available.");
        return;
      }

      // Convert base64 to binary data
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length)
        .fill()
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);

      // Create a blob and open it
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank", "width=900,height=700");
    } catch (error) {
      console.error("Error opening E-sign document:", error);
      alert("Failed to load the E-sign document. Please try again.");
    }
  };

  async function showEsignContract() {
    // Open a new popup window immediately to prevent popup blocking
    const popup = window.open("", "EsignPopup", "width=1000,height=800");

    if (!popup || popup.closed || typeof popup.closed === "undefined") {
      alert("Popup blocked! Please allow popups for this website.");
      return;
    }

    // Show a loading message while waiting for the API response
    popup.document.write(
      '<h3 style="font-family: sans-serif;">Loading eSign consent...</h3>'
    );

    try {
      const response = await api.post(
        `advisor/esignConsent`,
        { client_id: roomId }
      );
      console.log("response", response);

      // api returns a status code (200, 201, etc.)
      if (response.status === 200 && response.data?.html) {
        popup.document.open(); // Ensure it's open
        popup.document.write(response.data.html);
        popup.document.close();
      } else {
        popup.document.body.innerHTML =
          '<p style="color:red;">Error: Unable to load eSign consent form.</p>';
      }
    } catch (error) {
      console.error("Error opening E-sign document:", error);

      popup.document.body.innerHTML = `
          <h3 style="color:red;">Failed to load the E-sign document.</h3>
          <p>Please try again later or contact support.</p>
      `;

      alert("Failed to load the E-sign document. Please try again.");
    }
  }


  useEffect(() => {
    socket.on("nominee_declaration", (payload) => {

      const fromDeclarationFileUrl = Boolean(payload?.data?.fileUrl);
      setCanNomineeTrueFromDeclarationFileUrl(fromDeclarationFileUrl)
      console.log("Nominee declaration received:", payload, fromDeclarationFileUrl);
      // payload.room
      // payload.data.fileName
      // payload.data.fileUrl
      // payload.data.client_id
      // payload.data.response
    });

    // Cleanup listener
    return () => socket.off("nominee_declaration");
  }, []);


  console.log("isToggled", isToggled);

  const hasAddressProofData =
    kycDoc && kycDoc.find((doc) =>
      ["passport", "voterid", "dl", "aadhaar"].includes(doc.doctype)
    );
  const hasPancardData =
    kycDoc && kycDoc.find((doc) => doc.doctype === "pancard");
  const hasChequeData =
    kycDoc && kycDoc.find((doc) => doc.doctype === "cheque");
  const hasSignatureData =
    kycDoc && kycDoc.find((doc) => doc.doctype === "signature");
  const hasNRIContactDetailsData =
    kycDoc && kycDoc.find((doc) => doc.doctype === "nri_details");
  const hasContactDetailsData =
    kycDoc && kycDoc.find((doc) => doc.doctype === "contact_details");
  const hasNomineeDetailsData =
    kycDoc && kycDoc.find((doc) => doc.doctype === "nominee_details");

  // -----AddressProof Card ------
  const canOpenAddressProofImage = Boolean(
    !isToggled
  );
  const canOpenAddressProofForm = Boolean(
    !isToggled && hasAddressProofData?.data?.length > 0
  );
  const canAddressProofTrue = Boolean(
    hasAddressProofData?.data?.[0]?.data_status
  );
  const handleOpenAddressProof = () => setModalShowAddressForm(true);


  // -----Pan Card ------
  const canOpenPanCardImage = Boolean(
    // !isToggled && hasAddressProofData?.data?.[0]?.data_status,
    true,
  );
  const canOpenPanCard = Boolean(
    true,
    // !isToggled && hasPancardData?.data?.length > 0
  );
  const canPanCardTrue = Boolean(
    true,
    // hasPancardData?.data?.[0]?.data_status
  );
  const handleOpenPanCard = () => setModalShowPanCardForm(true);


  // -----Cheque Card ------
  const canOpenChequeImage = Boolean(
    !isToggled && hasAddressProofData?.data?.[0]?.data_status
  );
  const canOpenChequeForm = Boolean(
    !isToggled
  );
  const canChequeTrue = Boolean(
    hasChequeData?.data?.[0]?.data_status
  );
  const handleOpenCheque = () => setModalShowChequeForm(true);


  // -----Signature Card ------
  const canOpenSignatureImage = Boolean(
    !isToggled && hasChequeData?.data?.[0]?.data_status && hasPancardData?.data?.[0]?.data_status && hasAddressProofData?.data?.[0]?.data_status
  );
  const canSignatureTrue = Boolean(
    hasSignatureData?.fin_doc_url_front
  );

  // ------Contact Details ------

  const canOpenContactForm = Boolean(
    !isToggled && hasSignatureData?.fin_doc_url_front && hasChequeData?.data?.[0]?.data_status
    && hasPancardData?.data?.[0]?.data_status && hasAddressProofData?.data?.[0]?.data_status
  );
  const canContactTrue = Boolean(
    hasContactDetailsData?.data?.[0]?.data_status
  );


  // ------NRI Details ------

  // const canOpenNRIForm = Boolean(
  //   !isToggled && hasSignatureData?.fin_doc_url_front && hasChequeData?.data?.[0]?.data_status 
  //   && hasPancardData?.data?.[0]?.data_status && hasAddressProofData?.data?.[0]?.data_status
  // );
  // const canNRITrue = Boolean(
  //   hasNRIContactDetailsData?.data?.[0]?.data_status 
  // );

  // ------Nominee Details ------

  const canOpenNomineeForm = Boolean(
    !isToggled && hasSignatureData?.fin_doc_url_front && hasChequeData?.data?.[0]?.data_status
    && hasPancardData?.data?.[0]?.data_status && hasAddressProofData?.data?.[0]?.data_status
  );
  const canNomineeTrue = Boolean(
    hasNomineeDetailsData?.data?.[0]?.data_status
  );

  // const showSubmitButton = Boolean(
  //   !isToggled && (canNomineeTrueFromDeclarationFileUrl ? canNomineeTrueFromDeclarationFileUrl : hasNomineeDetailsData?.data?.[0]?.data_status) && hasSignatureData?.fin_doc_url_front
  //   && hasChequeData?.data?.[0]?.data_status
  //   && hasPancardData?.data?.[0]?.data_status && hasAddressProofData?.data?.[0]?.data_status
  // );
  // const showSubmitButton = Boolean(
  //   !isToggled && hasNomineeDetailsData?.data?.[0]?.data_status && hasSignatureData?.fin_doc_url_front
  //   && hasChequeData?.data?.[0]?.data_status
  //   && hasPancardData?.data?.[0]?.data_status && hasAddressProofData?.data?.[0]?.data_status
  // );
  // (clientData?.kyc_info?.identity !== "03" )

  const showSubmitButton = Boolean(
  !isToggled &&
  // ✅ Check nominee status ONLY if identity !== "03"
  (
    clientData?.kyc_info?.identity === "03" ||
    hasNomineeDetailsData?.data?.[0]?.data_status
  ) &&
  hasSignatureData?.fin_doc_url_front &&
  hasChequeData?.data?.[0]?.data_status &&
  // hasPancardData?.data?.[0]?.data_status &&
  hasAddressProofData?.data?.[0]?.data_status
);

  // console.log('showSubmitButton',isToggled,hasPancardData?.data?.[0]?.data_status,(canNomineeTrueFromDeclarationFileUrl? canNomineeTrueFromDeclarationFileUrl:hasNomineeDetailsData?.data?.[0]?.data_status));


  return (
    <>
      <div className="container minht">
        <div className="row ">
          <div className="col-md-10 col-12">
            <h2>Let's start your investments!</h2>
          </div>
          <div className="col-md-2 col-12 d-flex align-items-center justify-content-center">
            <div className="form-check form-switch">
              <label
                className="form-check-label"
                htmlFor="flexSwitchCheckDefault"
              >
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked={isToggled}
                  onChange={handleToggle}
                />
              </label>
            </div>
          </div>
        </div>

        <div className="row pt-5 text-center row-cols-md-6 row-cols-1 justify-content-center">
          <div>
            <div
              className="border border-1 py-3 mobheight brdr flex flex-cols items-center justify-center mb-2"
              style={{ cursor: "pointer" }}
              onClick={canOpenAddressProofImage ? () => setModalShowAddressType(true) : null}
            >
              <div className=" w-full h-full flex flex-cols items-center justify-center gap-2 ">
                <p className="reward24 md:postionleft">Address Proof</p>
                <img
                  src="/assets/images/passport-and-tickets.png"
                  alt=""
                  className="md:postionright mt-5"
                />
              </div>
            </div>
            <div className="mt-4 text-center">
              {/* View/Edit Label */}
              <p
                className={`m-0 ${canOpenAddressProofForm ? "text-success" : "text-muted"
                  }`}
                style={{
                  cursor: canOpenAddressProofForm
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={canOpenAddressProofForm ? handleOpenAddressProof : undefined
                }
              >
                View/Edit
              </p>

              {/* Status Icons (Shown only when editable) */}
              {canAddressProofTrue && (
                <div className="mt-1 d-flex justify-content-center align-items-center gap-3">
                  <span role="button" aria-label="Approved" title="Approved">
                    {/* <FaCheck className="text-success" style={{ fontWeight: 'bold' }} />     */}
                    ✔️
                  </span>
                  {/* <span role="button" aria-label="Cancel" title="Cancel">
                    <MdCancel className="text-danger" />
                  </span> */}
                </div>
              )}
            </div>
          </div>

          {/* PanCard */}

          <div>
            <div className="my-5 mt-md-0 border border-1 py-3 mobheight brdr mb-2">
              <label htmlFor="panImage" style={{ cursor: "pointer" }}>
                <p className="reward24 md:postionleft">PAN Card</p>
                <img
                  src="/assets/images/pan-card.svg"
                  alt="Pan card icon"
                  className="md:postionright mt-5 brdr"
                />
                <Form.Control
                  id="panImage"
                  type="file"
                  accept="image/*"
                  onChange={handlePanImageChange}
                  style={{ display: "none" }}
                  disabled={!canOpenPanCardImage} // 👈 use your flag here
                />
              </label>
            </div>

            {/* View/Edit Button */}
            <p
              className={`m-0 ${canOpenPanCard ? "text-success" : "text-muted"}`}
              style={{
                cursor: canOpenPanCard ? "pointer" : "not-allowed",
                pointerEvents: canOpenPanCard ? "auto" : "none",
              }}
              role="button"
              onClick={canOpenPanCard ? handleOpenPanCard : undefined}
            >
              View/Edit
            </p>

            {/* Icons - Only visible when editable */}
            {canPanCardTrue && (
              <div className="mt-1 d-flex justify-content-center align-items-center gap-3">
                <span role="button" aria-label="Approved" title="Approved">
                  ✔️
                </span>
                {/* Agar reject/cancel bhi dikhana hai to uncomment karo */}
                {/* <span role="button" aria-label="Cancel" title="Cancel">
                  <MdCancel className="text-danger" />
                </span> */}
              </div>
            )}

          </div>

          {/* Cheque */}

          <div>
            <div className="my-5 mt-md-0 border border-1 py-3 mobheight brdr mb-2">
              <label htmlFor="cheque" style={{ cursor: "pointer" }}>
                <p className="reward24 md:postionleft">
                  Cheque <br />
                  (Optional)
                </p>
                <img
                  src="/assets/images/receipt.svg"
                  alt=""
                  className="md:postionright mt-4"
                />
                <Form.Control
                  id="cheque"
                  type="file"
                  accept="image/*"
                  onChange={handleChequeChange}
                  // disabled={!isToggled}
                  style={{ display: "none" }}
                  disabled={!canOpenChequeImage}

                />
              </label>
            </div>

            <p
              className={`m-0 ${canOpenChequeForm ? "text-success" : "text-muted"}`}
              style={{
                cursor: canOpenChequeForm ? "pointer" : "not-allowed",
                pointerEvents: canOpenChequeForm ? "auto" : "none",
              }}
              role="button"
              onClick={canOpenChequeForm ? handleOpenCheque : undefined}
            >
              View/Edit
            </p>
            {/* Action Icons (Shown only when edit is enabled) */}
            {canChequeTrue && (
              <div className="mt-1 d-flex justify-content-center align-items-center gap-3">
                <span role="button" aria-label="Approved" title="Approved">
                  {/* <FaCheck className="text-success" /> */}
                  ✔️
                </span>
                {/* <span role="button" aria-label="Cancel" title="Cancel">
                    <MdCancel className="text-danger" />
                  </span> */}
              </div>
            )}
          </div>
        </div>

        {/* signature */}
        <div className="row  pt-5 text-center row-cols-md-6 row-cols-1 justify-content-center">
          <div>
            <div className="my-5 my-md-0 border border-1 py-3 mobheight brdr">
              <label htmlFor="signature" style={{ cursor: "pointer" }}>
                <div className=" w-full h-full flex flex-cols items-center justify-center gap-2 ">
                  <p className="reward24 md:postionleft">Signature</p>
                  <img
                    src="/assets/images/signature.png"
                    alt=""
                    className="md:postionright mt-1"
                  />
                </div>
                <Form.Control
                  id="signature"
                  type="file"
                  accept="image/*"
                  onChange={handleSignatureChange}
                  style={{ display: "none" }}
                  disabled={!canOpenSignatureImage}

                />
              </label>
            </div>
            {canSignatureTrue && (
              // hasSignatureData?.fin_doc_url_front && (
              <div className="mt-1 d-flex justify-content-center align-items-center gap-3">
                <span role="button" aria-label="Approved" title="Approved">
                  {/* <FaCheck className="text-success" /> */}
                  ✔️
                </span>
                {/* <span role="button" aria-label="Cancel" title="Cancel">
                    <MdCancel className="text-danger" />
                  </span> */}
              </div>
            )}
          </div>
          {clientData?.kyc_info?.identity === "21" ||
            clientData?.kyc_info?.identity === "24" ? (
            <>
              <div
                className={` ${canOpenContactForm ? "disabled" : ""}`}
                onClick={canOpenContactForm ? (() => setModalContactDetails(true)) : undefined}
                style={{ cursor: "pointer" }}
              >
                <div className="my-5 my-md-0 border border-1 py-3 mobheight brdr">
                  <div className=" w-full h-full flex flex-cols items-center justify-center gap-2 ">
                    <p className="reward24 md:postionleft">Contact Details</p>
                    <img
                      src="/assets/images/contact.png"
                      alt=""
                      className="md:postionright  mb-5 w-50 w-md-75 mobcontactwidth"
                    />
                  </div>
                </div>
                {canContactTrue && (
                  <div className="mt-1 d-flex justify-content-center align-items-center gap-3">
                    <span role="button" aria-label="Approved" title="Approved">
                      {/* <FaCheck className="text-success" /> */}
                      ✔️
                    </span>
                    {/* <span role="button" aria-label="Cancel" title="Cancel">
                    <MdCancel className="text-danger" />
                  </span> */}
                  </div>
                )}
              </div>


              <div
                className={` ${canOpenNomineeForm ? "disabled" : ""
                  }`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (canOpenNomineeForm) {
                    setModalNomineeDetails(true);
                  }
                }}
              >
                <div className="my-5 my-md-0 border border-1 py-3 mobheight brdr">
                  <div className=" w-full h-full flex flex-cols items-center justify-center gap-2 ">
                    <p className="reward24 md:postionleft">Nominee Details</p>
                    <img
                      src="/assets/images/nominee.svg"
                      alt=""
                      className="md:postionright mt-5"
                    />
                  </div>
                </div>
                {(canNomineeTrue
                  // || canNomineeTrueFromDeclarationFileUrl
                ) && (
                    // isViewChequeProofEditDisabled
                    <div className="mt-1 d-flex justify-content-center align-items-center gap-3">
                      <span role="button" aria-label="Approved" title="Approved">
                        {/* <FaCheck className="text-success" /> */}
                        ✔️
                      </span>
                      {/* <span role="button" aria-label="Cancel" title="Cancel">
                    <MdCancel className="text-danger" />
                  </span> */}
                    </div>
                  )}
              </div>

            </>
          ) : (
            <>
              {clientData?.kyc_info?.identity !== "03" &&
                <div
                  className={` ${canOpenNomineeForm ? "disabled" : ""
                    }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (canOpenNomineeForm) {
                      setModalNomineeDetails(true);
                    }
                  }}
                >
                  <div className="my-5 my-md-0 border border-1 py-3 mobheight brdr">
                    <div className=" w-full h-full flex flex-cols items-center justify-center gap-2 ">
                      <p className="reward24 md:postionleft">Nominee Details</p>
                      <img
                        src="/assets/images/nominee.svg"
                        alt=""
                        className="md:postionright mt-5"
                      />
                    </div>
                  </div>
                  {(canNomineeTrue
                    // || canNomineeTrueFromDeclarationFileUrl
                  ) && (
                      // isViewChequeProofEditDisabled
                      <div className="mt-1 d-flex justify-content-center align-items-center gap-3">
                        <span role="button" aria-label="Approved" title="Approved">
                          {/* <FaCheck className="text-success" /> */}
                          ✔️
                        </span>
                        {/* <span role="button" aria-label="Cancel" title="Cancel">
                    <MdCancel className="text-danger" />
                  </span> */}
                      </div>
                    )}
                </div>
              }


            </>
          )}


          {clientData?.kyc_info?.is_kyc_done !== "yes" && (
            <div onClick={handWebCamClick} style={{ cursor: "pointer" }}>
              <div className="my-5 my-md-0  border border-1 py-3 mobheight brdr">
                <div className=" w-full h-full flex flex-cols items-center justify-center gap-2 ">
                  <p className="reward24 md:postionleft">Webcam & MIC</p>
                  <img
                    src="/assets/images/webcam.svg"
                    alt="Webcam Icon"
                    className="md:postionright w-50 mb-5"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {isWebCamSec && (
          <>
            <div className="row pt-5 justify-content-center">
              {/* Webcam Image Card */}
              <div className="col-12 col-md-4 mb-4">
                <Card className="h-100">
                  <div className="py-3 mobheight px-2 brdr text-center">
                    <p className="reward24 md:postionleft">Webcam</p>
                    {clientAddressProofPhoto.length > 0
                      && clientAddressProofPhoto[0]?.fin_doc_url_front
                      ? (
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                            width: "100%",
                          }}
                        >
                          <p className="reward24 md:postionleft">
                            Captured Image:
                          </p>
                          <img
                            src={clientAddressProofPhoto[0]?.fin_doc_url_front}
                            alt="Captured"
                            className="md:postionright w-50 mb-5"
                          />
                        </div>
                      ) : (
                        <img
                          src="/assets/images/webcam.svg"
                          alt="Webcam Icon"
                          className="md:postionright w-50 mb-5"
                        />
                      )}
                  </div>

                  {/* </div> */}
                </Card>
              </div>

              {/* Video Capture Card */}
              {!kycDoc?.some((doc) => ["dl", "aadhaar"].includes(doc.doctype)) &&
                <div className="col-12 col-md-4 mb-4">
                  <Card className="h-100">
                    <div className="p-3">
                      <CaptureVideo kycDoc={kycDoc} roomId={roomId} />
                    </div>
                  </Card>
                </div>
              }
            </div>
          </>
        )}

        <div
          className="row mt-3 justify-content-center abc1"
          style={{ display: " none" }}
        >
          <div className="col-md-5">
            <p>
              The nominee for my investments is{" "}
              <input
                type="search"
                name=""
                id=""
                value="Nominee Name"
                className="float-end"
              />
              ,
            </p>
          </div>
          <div>
            <p>
              who is my
              <select
                className="form-select w-75 float-end"
                aria-label="Default select example"
              >
                <option selected>select</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </p>
          </div>
          <div>
            <p>
              ,and whose date of birth is{" "}
              <input
                type="date"
                name=""
                id=""
                className="form-control float-end"
                style={{ width: "40%" }}
              />
            </p>
          </div>
        </div>

        <div
          className="row mt-3 justify-content-start abc1"
          style={{ display: "none" }}
        >
          <div>
            <p>
              My Mother's full name is{" "}
              <input
                type="search"
                name=""
                id=""
                value="Mother's Name"
                className=""
              />
            </p>
          </div>
        </div>

        <div
          className="row mt-3 justify-content-center abccontact"
          style={{ display: "none" }}
        >
          <div className="col-md-12">
            <p>
              Complete Overseas Address{" "}
              <input
                type="text"
                name=""
                id=""
                placeholder="Address"
                className=""
              />
              ,
            </p>
          </div>
          <div className="col-md-4">
            <p>
              Overseas City{" "}
              <select
                className="form-select w-75 float-end"
                aria-label="Default select example"
              >
                <option selected>City</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </p>
          </div>
          <div className="col-md-4">
            <p>
              Overseas Picode
              <input
                type="number"
                name=""
                id=""
                placeholder="Pincode"
                className="ms-2"
              />
            </p>
          </div>
          <div className="col-md-4">
            <p>
              Overseas country{" "}
              <select
                className="form-select w-50 float-end"
                aria-label="Default select example"
              >
                <option selected>City</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </p>
          </div>
        </div>

        <div
          className="row mt-3 justify-content-center abc"
          style={{ display: "none" }}
        >
          <div
            className="col-md-2 text-center"
            data-bs-toggle="modal"
            data-bs-target="#exampleModalphoto"
            style={{ cursor: "pointer!important" }}
          >
            <div className="border border-1 py-3 mobheight px-2 brdr">
              <p className="reward24 postionleft">Photo</p>
              <img
                src="/assets/images/photo.svg"
                alt=""
                className="postionright mt-2 w-50"
              />
            </div>
          </div>
          <div
            className="modal fade"
            id="exampleModalphoto"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{ backgroundColor: "#23674B !important" }}
                >
                  <h1
                    className="modal-title fs-5 text-white"
                    id="exampleModalLabel"
                  >
                    Capture Photo
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div
                      className="col-12 bg-dark"
                      style={{ height: " 200px!important" }}
                    ></div>
                    <div className="col-12 text-center pt-2">
                      <img src="/assets/images/upload.png" alt="" />
                      <p style={{ fontSize: "14px" }}>
                        Note :- Please ensure good background lighting and a
                        non-blurry picture!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary col"
                    style={{ backgroundColor: "#23674B !important" }}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-md-2 text-center"
            data-bs-toggle="modal"
            data-bs-target="#exampleModalvideo"
            style={{ cursor: " pointer!important" }}
          >
            <div className="border border-1 py-3 mobheight px-2 brdr">
              <p className="reward24 postionleft">Video</p>
              <img
                src="/assets/images/video.svg"
                alt=""
                className="postionright mt-2 w-50"
              />
            </div>
          </div>
          <div
            className="modal fade"
            id="exampleModalvideo"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{ backgroundColor: "#23674B !important" }}
                >
                  <h1
                    className="modal-title fs-5 text-white"
                    id="exampleModalLabel"
                  >
                    Record video
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-12 p-0">
                      <div
                        className="text-center"
                        style={{ backgroundColor: "#23674B !important" }}
                      >
                        <h4 className="text-white">0 3 5 6 2 7</h4>
                      </div>
                    </div>
                    <div
                      className="col-12 bg-dark"
                      style={{ height: " 200px!important" }}
                    ></div>
                    <div className="col-12 text-center pt-2">
                      <img src="/assets/images/record.png" alt="" />
                      <p style={{ fontSize: "14px" }}>
                        Note :- Please Start recording and read out the
                        Displayed Number Sequence Clearly
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary col"
                    style={{ backgroundColor: "#23674B !important" }}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="d-flex justify-content-center mt-3 mb-3">
            <span>
              {/* <button
                className="btnactive clr active pt-1 text-white"
                onClick={() => setModalApplicantForml(true)}
              >
                Submit
                <img src="assets/images/right.png" alt="Right arrow" />
              </button> */}
              {/* <button onClick={openApplicantForm} className="btn btn-primary">
                Next
              </button> */}

              {clientData?.kyc_info?.is_kyc_done === 'no'
                // (clientAddressProofVideo?.[0]?.fin_doc_url_front ||clientAddressProofPhoto?.[0]?.fin_doc_url_front)
                && (
                  <p className="text-center fw-semibold clrgreen">
                    To view the contract
                    <span
                      className="text-info"
                      style={{ cursor: "pointer" }}
                      onClick={openEsignDocument}
                    >
                      {" "}
                      Click here
                    </span>{" "}
                    & To E-sign the contract
                    <span
                      className="text-info"
                      style={{ cursor: "pointer" }}
                      onClick={showEsignContract}
                    >
                      {" "}
                      Click here
                    </span>
                    .
                  </p>
                )}

              <h4 className="text-center txt-color">{errorStatusMessage}</h4>

              {/* {hasNomineeDetailsData?.data?.[0]?.data_status && ( */}

              <ApplicantForm clientData={clientData} showSubmitButton={showSubmitButton} hasNomineeDetailsData={hasNomineeDetailsData} isConnected={isConnected} />
              {/* )} */}
            </span>
          </div>
        </div>

        {/* <div className="row">
          <div className="col text-center">
            <p className="clrgreen" style={{ fontSize: " 28px!important" }}>
              Upload The Address Proof
            </p>
          </div>
        </div> */}
      </div>

      {/* Address Proof card*/}

      <KycStatusListener clientId={roomId} />
      <AddressProofTypeModal
        show={modalShowAddressType}
        onHide={handleAddressProofTypeModal}
        onSave={handleAddressType}
        roomId={roomId}
        setSelectedProofType={setSelectedProofType}
        selectedProofType={selectedProofType}
        kycDoc={clientData?.kyc_doc}
        clientData={clientData}
      />
      <EditAddressProofTypeModal
        show={modalShowEditAddressType}
        setModalShowEditAddressType={setModalShowEditAddressType}
        onHide={handleAddressProofTypeModal}
        onSave={handleAddressType}
        roomId={roomId}
        setSelectedProofType={setSelectedProofType}
        selectedProofType={selectedProofType}
        kycDoc={clientData?.kyc_doc}
        clientData={clientData}
      // setModalShowAddressForm={setModalShowAddressForm}
      />
      <AddressProofFormModal
        roomId={roomId}
        show={modalShowAddressForm}
        onHide={() => {
          setModalShowAddressForm(false);
          setSelectedProofType(null);
        }}
        onSave={handleAddressForm}
        proofType={"Address Proof"}
        kycDoc={clientData?.kyc_doc}
        selectedProofType={selectedProofType}
      />

      {/* PanCardForm Proof card*/}
      <PanCardForm
        show={modalShowPanCardForm}
        onHide={() => setModalShowPanCardForm(false)}
        onSave={handlePanCardForm}
        proofType={"PAN Card"}
        kycDoc={clientData?.kyc_doc}
        roomId={roomId}
      />

      <ChequeFormModal
        show={modalShowChequeForm}
        onHide={() => setModalShowChequeForm(false)}
        onSave={handleChequeForm}
        proofType={"Cheque "}
        kycDoc={clientData?.kyc_doc}
        roomId={roomId}
      />
      <SignatureCropModal
        show={modalSignatureFile}
        onHide={() => setModalSignatureFile(false)}
        signatureFile={signatureFile}
        setSignatureFile={setSignatureFile}
        roomId={roomId}
      />
      <NomineeDetailsModal
        show={modalNomineeDetails}
        onHide={nomineeDetailsModalHide}
        setAlertMessage={setAlertMessage}
        alertMessage={alertMessage}
        proofType={"Nominee"}
        clientData={clientData}
        kycDoc={kycDoc}
        fileUrl={fileUrl}
        setFileUrl={setFileUrl}
        roomId={roomId}
      />
      <ContactDetailsModal
        show={modalContectDetails}
        onHide={contactDetailsModalHide}
        setAlertMessage={setAlertMessage}
        alertMessage={alertMessage}
        proofType={"Contact"}
        clientData={clientData}
        kycDoc={kycDoc}
        roomId={roomId}
      />

      {/* <ApplicantFormModal
        show={modalApplicantForml}
        onHide={() => setModalApplicantForml(false)}
      /> */}

      <div className="container mb-3">
        <div className="row ">
          <div className="col text-end">
            <a href="javascript:void(0);" onClick={handleBack}>
              <img
                className="arrow_next1"
                src="/assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            {/* <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a> */}
          </div>
        </div>
      </div>

      {/* <div id="applicant-form" style={{ display: "none", margin: "10px" }}>
        <ApplicantForm />
      </div> */}
    </>
  );
};
